import { useState } from 'react';
import { Modal, Button, Spin } from 'antd';
import { ExpandAltOutlined } from '@ant-design/icons';
import { EventsByLocationChartLogic } from './EventsByLocationChart';
import './EventsByLocationChart.scss';
import { AgCharts } from 'ag-charts-react';
import { ModuleRegistry, AllEnterpriseModule } from 'ag-charts-enterprise';
import LoadingOrbitalSpinner from '../LoadingOrbitalSpinner/LoadingOrbitalSpinner';

ModuleRegistry.registerModules([AllEnterpriseModule]);

function EventsByLocationChart({ startAndEndUnixDatesParams = '', formatDateRange = '' }) {
    const { EventsByLocationConfig, loading } = EventsByLocationChartLogic(startAndEndUnixDatesParams, formatDateRange);
    const [modalOpen, setModalOpen] = useState(false);

    return (
        
      <Spin spinning={loading} indicator={<LoadingOrbitalSpinner />}>
        <div className='events-by-location-chart-wrapper' style={{ flex: '1', minWidth: '300px' }}>
            <div className='events-by-location-chart'>
                <Button
                    className='events-by-location-chart-expand-btn'
                    type='text'
                    size='small'
                    icon={<ExpandAltOutlined />}
                    onClick={() => setModalOpen(true)}
                />
                {EventsByLocationConfig && <AgCharts
                    options={EventsByLocationConfig}
                />}
            </div>
            <Modal
                centered
                open={modalOpen}
                onCancel={() => setModalOpen(false)}
                footer={null}
                width='90%'
            >
                {EventsByLocationConfig && <AgCharts options={EventsByLocationConfig} style={{ height: '70vh' }} />}
            </Modal>
        </div>
    </Spin>
    )
}

export default EventsByLocationChart
